import React from "react";
import { TEXT_PRIMARY } from "../../lib/colors";

type YearCounterProps = {
  year: number;
};

const YearCounter: React.FC<YearCounterProps> = ({ year }) => {
  return (
    <div
      style={{
        position: "absolute",
        right: 100,
        bottom: 120,
        fontSize: 192,
        fontWeight: 800,
        color: TEXT_PRIMARY,
        opacity: 0.25,
        fontFamily: "'Segoe UI', Meiryo, sans-serif",
        lineHeight: 1,
        pointerEvents: "none",
        userSelect: "none",
      }}
    >
      {Math.floor(year)}
    </div>
  );
};

export default YearCounter;
